/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTeamRole } from './';
import {
    ClientTeamRoleFromJSON,
    ClientTeamRoleFromJSONTyped,
    ClientTeamRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyUpdateMemberRoleRequest
 */
export interface ClientCompanyUpdateMemberRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyUpdateMemberRoleRequest
     */
    companyId: string;
    /**
     * 
     * @type {ClientTeamRole}
     * @memberof ClientCompanyUpdateMemberRoleRequest
     */
    role: ClientTeamRole;
}

/**
 * Check if a given object implements the ClientCompanyUpdateMemberRoleRequest interface.
 */
export function instanceOfClientCompanyUpdateMemberRoleRequest(value: object): value is ClientCompanyUpdateMemberRoleRequest {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function ClientCompanyUpdateMemberRoleRequestFromJSON(json: any): ClientCompanyUpdateMemberRoleRequest {
    return ClientCompanyUpdateMemberRoleRequestFromJSONTyped(json, false);
}

export function ClientCompanyUpdateMemberRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyUpdateMemberRoleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'role': ClientTeamRoleFromJSON(json['role']),
    };
}

export function ClientCompanyUpdateMemberRoleRequestToJSON(value?: ClientCompanyUpdateMemberRoleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'role': ClientTeamRoleToJSON(value['role']),
    };
}

